import React, { Component } from "react";
import { LiveProvider, LivePreview } from "react-live";
import { RenderDateTime, RenderCurrency, RenderNumber } from "Utils/renderField/renderReadField";
import { icons } from "icons";

const getDateObject = (value) => {
    const fecha = new Date(value);
    return {
        day: fecha.getDate(),
        month: fecha.getMonth() + 1,
        year: fecha.getFullYear().toString().substring(2),
        fullYear: fecha.getFullYear(),
    };
};

export default class Despacho extends Component {
    render() {
        const { datos_despacho, formato_despacho, className } = this.props;

        //console.log("DATOS DESPACHO PREVIEW:", datos_despacho);
        //console.log("FORMATO DESPACHO PREVIEW:", formato_despacho);

        if (!formato_despacho || !datos_despacho) return null;

        return (
            <div className={className || ""}>
                <LiveProvider
                    code={formato_despacho}
                    noInline={false}
                    scope={{
                        ...datos_despacho,
                        RenderCurrency,
                        RenderNumber,
                        RenderDateTime,
                        icons,
                        getDateObject
                    }}
                >
                    <LivePreview />
                </LiveProvider>
            </div>
        );
    }
}